import React, { useState } from 'react';
import { FadeIn } from './FadeIn';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  question: '¿Qué es Amazon Master System™?',
  answer: 'Es un programa de formación que reúne una ruta organizada para aprender Amazon desde cero, incluyendo fundamentos, Amazon FBA, Amazon FBM, investigación de productos, publicación y escalamiento.'
}, {
  question: '¿Cuándo recibo acceso?',
  answer: 'El acceso es inmediato después de completar el pago. Recibirás la información necesaria para comenzar de forma digital.'
}, {
  question: '¿Necesito experiencia previa?',
  answer: 'No. El contenido está organizado para principiantes y avanza paso a paso desde los conceptos fundamentales.'
}, {
  question: '¿Incluye Amazon FBA y Amazon FBM?',
  answer: 'Sí. El programa incluye ambos modelos para que puedas entender cómo funcionan y construir una base más completa.'
}, {
  question: '¿Puedo acceder desde celular o computadora?',
  answer: 'Sí. Puedes consultar el material desde computadora, tablet o celular, según te resulte más cómodo.'
}, {
  question: '¿Las actualizaciones están incluidas?',
  answer: 'Sí. Tu acceso incluye las actualizaciones futuras disponibles para el programa.'
}];
export function PreguntasFrecuentes() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="bg-brand-white px-5 py-20 sm:px-6 md:py-28" data-id="element-497">
      <div className="mx-auto max-w-3xl" data-id="element-498">
        <FadeIn data-id="element-499">
          <div className="mb-12 text-center md:mb-14" data-id="element-500">
            <p className="mb-3 text-xs font-bold uppercase tracking-[0.2em] text-brand-gold" data-id="element-501">
              Resolvemos tus dudas
            </p>
            <h2 className="font-serif text-3xl font-bold tracking-tight text-brand-green sm:text-4xl md:text-5xl" data-id="element-502">
              Preguntas frecuentes
            </h2>
          </div>
        </FadeIn>

        <div className="divide-y divide-brand-text/10 rounded-2xl border border-brand-text/10 bg-white" data-id="element-503">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <FadeIn key={faq.question} delay={0.04 * index} data-id="element-504">
                <div data-id="element-505">
                  <button type="button" onClick={() => setOpenIndex(current => current === index ? null : index)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-5 px-6 py-5 text-left sm:px-7 sm:py-6" data-id="element-506">
                    <span className="text-base font-bold text-brand-green sm:text-lg" data-id="element-507">
                      {faq.question}
                    </span>
                    <ChevronDown className={`h-5 w-5 flex-shrink-0 text-brand-gold transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`} data-id="element-508" />
                  </button>
                  {isOpen && <div className="px-6 pb-6 sm:px-7 sm:pb-7" data-id="element-509">
                      <p className="max-w-2xl text-sm leading-relaxed text-brand-text/70 sm:text-base" data-id="element-510">
                        {faq.answer}
                      </p>
                    </div>}
                </div>
              </FadeIn>;
        })}
        </div>
      </div>
    </section>;
}